
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Detail">
    <!-- <div
      class="d-flex flex-column align-items-start flex-lg-row align-items-lg-center"
    >
      <h2 class="text-primary mb-1 mr-2 text-md-nowrap font-40px">
        {{ getWork.name }}
        <span
          class="d-none d-lg-inline"
          v-if="$route.name === 'WorksOperation' && Object.keys(getOperation).length"
        >
          /
        </span>
      </h2>

      <template v-if="$route.name === 'WorksOperation' && Object.keys(getOperation).length" >
        <h3
          class="bold text-primary mb-1 mr-2 text-md-truncate font-30px"
          v-b-tooltip.hover
          :title="getOperation.name"
        >
          {{ getOperation.name }}
        </h3>
        <h4 class="bold text-primary mb-1 mr-2 text-md-nowrap">
          <span class="d-none d-lg-inline"> - </span
          >{{ getOperation.plug_cee.name }}
        </h4>
         <b-badge variant="light" pill class="mb-1 py-1 px-4">{{
        getOperation.status
      }}</b-badge>
      </template>

      <b-badge v-if="$route.name !== 'WorksOperation'" variant="primary" pill class="mb-1 py-1 px-4">{{
          $t(getWork.status)
      }}</b-badge>
    </div> -->
      <action-link v-if="$route.name !== 'WorksOperation'" :id="getWork.id"></action-link>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ActionLink from '../../components/static/work/ActionLink.vue';
export default {
  components: { ActionLink },
  name: 'Detail',
  data() {
    return {};
  },
  mounted() {
    this.getWorkByIdAction({ id: parseInt(this.$route.params['id'], 10) ,loaded: true});
  },
  computed: {
    ...mapGetters('work', ['getWork', 'getOperation', 'getMessageries']),
  },
  methods: {
    ...mapActions('work', ['getWorkByIdAction', 'getMessageriesAction']),
  },
};
</script>
